import { Outlet } from 'react-router-dom';
import { Users, Building2, Box } from 'lucide-react';
import type { MenuItemsType } from '@duke-hq/ui/components/SubSidebar/MenuItems';
import { SidebarLayout } from '@duke-hq/ui/components/SubSidebar/SidebarLayout';
import { t } from '@lingui/core/macro';
import { withPermission } from '../withPermission';

export const PlacementsLayout = withPermission('canManageWorkPlacements', () => {
  const items: MenuItemsType[] = [
    {
      label: t`Students`,
      link: `/placements/students`,
      icon: Users,
    },
    {
      label: t`Employers`,
      link: `/placements/employers`,
      icon: Building2,
    },
    {
      label: t`Courses`,
      link: `/placements/courses`,
      icon: Box,
    },
  ];

  return (
    <SidebarLayout items={items} label={t`Placements`}>
      <Outlet />
    </SidebarLayout>
  );
});
